import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  banner = { image: "../../../assets/images/about-us/about-us-bannar.jpg", title: "About Us", color: "#eafe38" }

  constructor() { }

  ngOnInit(): void {
  }

}
